import React, { useState } from "react";
import { Box, Menu, ListItemText, IconButton } from "@mui/material";
import CustomDropdown from "../Common/CustomDropdown";
import { formatClientDomain } from "../../utils/utils";
import { Client } from "../../utils/types";
import EllipsedTooltip from "../Common/EllipsedTooltip";


type Props = {
  clientName: string | null;
  canEdit: boolean;
  row: any;
  rowAction: any;
  clientList: Client[];
  noBorder?: boolean;
  showCrossIcon?: boolean; // 👈 NEW PROP
};

const ActionItemsAccountCell: React.FC<Props> = ({
  clientName,
  canEdit,
  row,
  rowAction,
  clientList,
  noBorder,
  showCrossIcon = true, // default true
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    if (canEdit) setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  const handleSelectAccount = (selected: Client | Client[] | null) => {
    if (!selected) return;
    const client = Array.isArray(selected) ? selected[0] : selected;
    rowAction.updateAccountCallback(row, client?.clientOrgId);

    handleClose();
  };

  const handleClear = (e: React.MouseEvent) => {
    e.stopPropagation();
    rowAction.updateAccountCallback(row, null, ["account"]);
  };

  const selectedClient = clientList?.find((c) => c?.clientName === clientName);
  const displayedLabel = selectedClient?.clientName
    ? selectedClient.clientName.charAt(0).toUpperCase() + selectedClient.clientName.slice(1)
    : clientName
    ? formatClientDomain(clientName)
    : "-";
  if (!clientName && !canEdit) return <Box sx={{ pl: 1 }}>-</Box>;

  return (
      <Box
        className={
          noBorder
            ? ""
            : `assignee-cell-wrapper ${
                open ? "assignee-cell-wrapper--active" : ""
              } ${!canEdit ? "no-hover" : ""}`
        }
        onClick={handleOpen}
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          gap: 1,
          cursor: canEdit ? "pointer" : "default",
          padding: "4px 8px",
          "&:hover .cross-icon": {
            opacity: showCrossIcon && canEdit ? 1 : 0,
            visibility: showCrossIcon && canEdit ? "visible" : "hidden",
          },
        }}
      >
          <EllipsedTooltip tooltipContent={!clientName && canEdit
            ? "Add Account"
            : displayedLabel} maxWidth="140px" >
          {displayedLabel}
          </EllipsedTooltip>

        {showCrossIcon && canEdit && clientName && (
            <IconButton
              className="cross-icon"
              size="small"
              onClick={handleClear}
              sx={{
                right: "4px",
                top: "50%",
                transform: "translateY(-50%)",
                position: "absolute"
              }}
            >
              <span>×</span>
            </IconButton>
        )}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{ style: { maxHeight: 300, minWidth: 120 } }}
        onClick={(e) => e.stopPropagation()}
        MenuListProps={{
          sx: {
            paddingTop: "0px !important",
            paddingBottom: "0px !important",
          },
        }}
      >
        <CustomDropdown<Client>
          items={clientList}
          value={selectedClient || null}
          onChange={(client) => {
            if (client) handleSelectAccount(client);
            else rowAction.updateAccountCallback(row, null);
          }}
          placeholder="Search by account"
          showSearch
          maxHeight={200}
          filterFn={(c, search) =>
            (c.clientName || "").toLowerCase().includes(search.toLowerCase())
          }
          forceShowList={clientList?.length <= 5}
          renderItem={(client) => (
            <div className="flex items-center">
              <ListItemText
                primary={client.clientName.charAt(0).toUpperCase() + client.clientName.slice(1)}
                primaryTypographyProps={{ noWrap: true }}
              />
            </div>
          )}
        />
      </Menu>
    </Box>
  );
};

export default ActionItemsAccountCell;
